const PAYMENT_ORDINAL_JOIN_CHAR = "_";

export function getPaymentsPagePaymentId({ id, ordinal }: { id: string; ordinal?: number | null }) {
    // NOTE: We accept null here to allow direct use as grid's getRowId
    return [id, ordinal].filter((x) => x != null).join(PAYMENT_ORDINAL_JOIN_CHAR);
}
export function parsePaymentsPagePaymentId(rowId: string): { paymentId: string; ordinal?: number } {
    const [paymentId, ...rest] = rowId.split(PAYMENT_ORDINAL_JOIN_CHAR);
    return { paymentId, ordinal: rest[0] == null ? undefined : parseInt(rest[0]) };
}
